module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-justify-a56c45c31cd880d6bd1d35b2320f2c86.svg";